export const CREATE_INVITE = 'invite/CREATE_INVITE';

export const CREATE_INVITE_AND_REDIRECT = 'invite/CREATE_INVITE_AND_REDIRECT';

export const FIND_INVITE = 'invite/FIND_INVITE';

export const CONFIRM_INVITE = 'invite/CONFIRM_INVITE';
